module.exports = __webpack_public_path__ + "img/semfulllogo.da7871dd.svg";